import { render, staticRenderFns } from "./partner-achievement-revision.vue?vue&type=template&id=e2b2b840&"
import script from "./partner-achievement-revision.vue?vue&type=script&lang=js&"
export * from "./partner-achievement-revision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports